import { APIClient } from "api/apiCore";
import { Utils } from "helpers/utils";
import * as urls from "../api/urls";
import { useEffect, useState } from "react";
import { useRedux } from "hooks";
import { createSelector } from "reselect";
import { getCurrentUserAction } from "../redux/profile2/p2_reducer";

interface ChangeViewAsProps {
  children: any;
  changeToId: number | null;
  changeToName: string;
  // onChangeViewAs: (changeToId: any, changeToName: any) => void;
}

const ChangeViewAs = ({ /*onChangeViewAs,*/ children, changeToId, changeToName }: ChangeViewAsProps) => {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.Profile2,
    (state) => ({
      curUserId: state.userId,
    })
  );
  const { curUserId } = useAppSelector(storeData);
  const [isSettingViewAs, setIsSettingViewAs] = useState<boolean>(false);

  useEffect(() => {
    // console.log('curUserId = ' + curUserId);
    if (isSettingViewAs) {
      // console.log('isSettingViewAs curUserId:' + curUserId);
      // dispatch(getChatUserDetails2s(null, true));
      // dispatch(setActiveGroupId(-1));
      // dispatch(changeSelectedChat(null));
      // const parm = {
      //   page: 1,
      //   filter: "",
      //   isFetchNext: false,
      //   filterUnread: null,
      //   filterPersonUnRead: null,
      //   filterNoActivity: null,
      //   filterSaleIds: undefined,
      //   filterCsIds: undefined,
      //   filterProvinceIds: undefined
      // }
      //dispatch(fetchChatContactsRequest(parm))
      window.location.reload();
    }
  }, [curUserId]);

  const onViewAsCustomerClick = () => {
    try {
      const api = new APIClient();
      if (changeToId) {
        Utils.SweetConfirm(`เปลี่ยนเป็นมุมมองของลูกค้า <br/><span class="text-red">${changeToName}</span><br/>ใช่หรือไม่`)
          .then((result) => {
            if (result.isConfirmed) {
              // console.log('member:', member);
              api.fnPostForm(urls.CHANGE_TO_CVIEW, { toUserId: changeToId })
                .then((rs) => {
                  if (rs.success) {
                    // navigate('/auth-login');
                    console.log('set view as = ' + changeToId);
                    setIsSettingViewAs(true);
                    dispatch(getCurrentUserAction());
                    // window.location.reload();
                    // console.log('rs:', rs);  
                  } else {
                    alert(rs.message);
                  }
                })
                .catch((error) => { });
              // dispatch(delUserFromGroup(member.groupId, userId));
            }
          })
          .catch((error) => {
            console.error('Error:', error);
          });
      } else {
        api.fnPostForm(urls.CHANGE_TO_CVIEW, { toUserId: null })
          .then((rs) => {
            if (rs.success) {
              setIsSettingViewAs(true);
              dispatch(getCurrentUserAction());
              //navigate('/auth-login');
              // window.location.reload();
              // console.log('rs:', rs);  
            } else {
              alert(rs.message);
            }
          })
          .catch((error) => { Utils.HandleException(error, true); });
      }
    } catch (e) {
      console.error(e);
      alert((e as any).message);
    }
  }

  return (
    <>
      <span onClick={onViewAsCustomerClick}>
        {children}
      </span>
    </>
  );
};

export default ChangeViewAs;
